import React from 'react'
import './Index.css'
import { SocialIcon } from 'react-social-icons';

const Index = () => {
    return (
        <div className = 'mt-2 row justify-content-center mb-2'>
            {/* <div className="col-md-4 text-white "  >
                <p style={{fontSize: '1.3vw'}} >@2021 WizWackTeam - Privacy and Terms</p>
            </div> */}
            <div className = 'col-auto col-md-auto SocialImage'>
            <SocialIcon url='https://www.instagram.com/wizwack.studios/' network="instagram"  className="ml-5 mr-5"  />
            <SocialIcon url='https://www.facebook.com/wizwackstudios/' network="facebook"   className="ml-5 mr-5"/>
            <SocialIcon url='https://in.linkedin.com/in/ankit-gupta-3701033a' network="linkedin"   className="ml-5 mr-5"/>
            <SocialIcon url='https://mobile.twitter.com/wizwackstudios' network="twitter"    className="ml-5 mr-5"/>
            <SocialIcon url='https://www.youtube.com/channel/UC811Hz7zxQoWT2bbBc1ekLA' network="youtube"    className="ml-5 mr-5"/>
            </div>
        </div>
    )
}

export default Index
